import React from 'react';
export default class MainItemWatcher extends React.Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.reactToMainVideoIdChange(nextProps);
  }
  reactToMainVideoIdChange(_ref) {
    let {
      mainItemIndex,
      firstItemAtFrameIndex,
      inFrameItemsCount,
      onFirstItemIndexUpdate,
      onForceLastItemUpdate
    } = _ref;
    if (mainItemIndex === -1 || mainItemIndex === this.props.mainItemIndex) {
      return;
    }
    const isMainItemAtViewFrame = mainItemIndex >= firstItemAtFrameIndex && mainItemIndex < firstItemAtFrameIndex + inFrameItemsCount;

    // just select main item if it is at view frame
    if (isMainItemAtViewFrame && inFrameItemsCount !== 1) {
      onForceLastItemUpdate((mainItemIndex - firstItemAtFrameIndex + 1) % inFrameItemsCount === 0);
      return;
    }

    // always make last if after to view frame
    if (mainItemIndex >= firstItemAtFrameIndex + inFrameItemsCount) {
      onFirstItemIndexUpdate(mainItemIndex - inFrameItemsCount + 1);
      if (inFrameItemsCount === 1) {
        return;
      }
      onForceLastItemUpdate(true);
      return;
    }

    // always make first if before to view frame
    onFirstItemIndexUpdate(mainItemIndex);
    onForceLastItemUpdate(false);
  }
  render() {
    return null;
  }
}
//# sourceMappingURL=main-item-watcher.js.map